/**
 * Created by andrey on 28.03.2024.
 */

const InstantLogger = function () {
    this.config = {
        lifetime: "14 days"
    };
};

InstantLogger.prototype.trackEvent = function (name, params) {
    if (typeof FBInstant === "undefined") {
        return;
    }

    FBInstant.logEvent(name, params.value);
};

InstantLogger.isApplicable = function () {
    return connector.platform.oneOf(connector.INSTANT);
};
